import clsx from 'clsx'
import React from 'react'
import { Modal } from 'react-bootstrap'
import { cloneChildComponents, DEPTH_1 } from '../utils/helpers'

// Generic modal wrapper for all integration modals
function GenericModal(props) {
  const { children, ...rest } = props // eslint-disable-line react/prop-types
  const { show, onCancel } = rest

  return (
    <Modal size="md" backdrop className={`engage-modal right ${clsx({ in: show })}`} show={show} onHide={onCancel}>
      {cloneChildComponents(rest, children, DEPTH_1)}
    </Modal>
  )
}

export default GenericModal
